import { graphql } from "gatsby"

export const query = graphql`
  fragment EventCard on WpMeshEvent {
    uri
    title
    # excerpt
    # startDate
    # endDate
    # allDay
    eventInformation {
        timeDate {
          startDate
          startTime
          endDate
          endTime
        }
        allDay
      }
    featuredImage {
        node {
            altText
            localFile {
                publicURL
                extension
                childImageSharp {
                    gatsbyImageData(width: 512)
                }
            }  
        }
    } 
  }
`


// Format month names
const monthNames = [
    "January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"
];

export function formatDate(startDateRaw, startTime, endDateRaw, endTime, allDay, format = "full") {
    const startDateTimeRaw = `${startDateRaw?.substring(0, 4)}/${startDateRaw?.substring(4, 6)}/${startDateRaw?.substring(6, 8)}${allDay ? "" : ` ${startTime}`}`
    const endDateTimeRaw = `${endDateRaw?.substring(0, 4)}/${endDateRaw?.substring(4, 6)}/${endDateRaw?.substring(6, 8)}${allDay ? "" : ` ${endTime}`}`

    // Convert strings to Date objects
    const start = new Date(startDateTimeRaw);
    const end = new Date(endDateTimeRaw);
    const now = new Date();

    // Format date parts
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    const startDate = start.getDate();
    const startDay = dayNames[start.getDay()];
    const endDate = end.getDate();
    const endDay = dayNames[end.getDay()];
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();
    const nowYear = now.getFullYear();
    const startMonth = monthNames[start.getMonth()];
    const endMonth = monthNames[end.getMonth()];
    // const startTime = start.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    // const endTime = end.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    const endsWithin24Hours = end.getTime() - start.getTime() < 86400000;
    function formatEndDate() {
        return endsWithin24Hours ? "" : ` - ${endDay}, ${endMonth} ${endDate}${endYear === nowYear ? "" : `, ${endYear}`}`
    }
    function formatStartDate() {
        return `${startDay}, ${startMonth} ${startDate}${((startYear !== endYear || format === "startDate") && startYear !== nowYear) ? `, ${startYear}` : ""}`
    }
    // function formatStartIso8601(){
    //     return `${startYear}-${startDate}-${startMonth}T${startTime}:00`
    // }
    // function getTimeZoneOffsetIso8601(){
    // return `${start.toISOString().substring(19, 22)}:${start.toISOString().substring(22, 24)}`
    // }

    function formatStartIso8601(type = "start") {
        const date = type === "start" ? start : end
        return allDay ? `${date.toISOString().substring(0, 10)}` : `${date.toISOString()}`
    }

    return (
        // Build the dateString
        format === "full" ?
            `${formatStartDate()}${formatEndDate()} ${allDay ? "" : `| ${startTime} - ${endTime}`}`
            : format === "date" || (format === "startDate" && allDay) ?
                `${formatStartDate()}${formatEndDate()}`
                : format === "startDateIso8601" ?
                    `${formatStartIso8601("start")}`
                    : format === "endDateIso8601" ?
                        `${formatStartIso8601("end")}`
                        : format === "startDate" && !allDay ?
                            `${formatStartDate()}`
                            : format === "time" && !allDay ?
                                `${allDay ? "" : `${startTime} - ${endTime}`}`
                                : null
    )

}
